import React from 'react';

export default function RegistroCaniem() {
  return (
    <div className="container mx-auto py-16 px-4">
      <h1 className="text-2xl font-semibold mb-6 text-center">Registro caniem</h1>
      <div className="max-w-4xl mx-auto">
        <iframe
          src="https://recursos.cenid.org/documentos/registrocaniem.pdf"
          title="Registro caniem"
          className="w-full h-[800px] border shadow rounded"
        />
        <p className="text-sm text-center mt-3">Si el PDF no se muestra, <a href="/documentos/registrocaniem.pdf" className="text-blue-600 underline">descárguelo aquí</a>.</p>
      </div>
    </div>
  );
}
